<template>
    <div class="pa-3">
        <v-snackbar
            v-model="showConfirm"
            color="#49C84F"
            text
            top
            right
            rounded
        >
            <v-icon
                color="#2FA84F"
                class="mr-3"
            >
                check_circle_outline
            </v-icon>
            User information updated successfully!

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="#2FA84F"
                    text
                    v-bind="attrs"
                    @click="showConfirm = false"
                >
                    <v-icon color="#2FA84F">
                        close
                    </v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <div class="mb-3">
            <span class="subtitle-1 font-weight-bold">
                Basic Details
            </span>
            <v-divider />
        </div>
        <v-row>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    Full Name
                </label>
                <v-text-field
                    v-model="fullName"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    Account
                </label>
                <v-text-field
                    v-model="account"
                    outlined
                    dense
                    hide-details
                    disabled
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    Type
                </label>
                <v-text-field
                    v-model="ingroup"
                    disabled
                    outlined
                    dense
                    hide-details
                />
            </v-col>
        </v-row>
        <div class="my-3">
            <span class="subtitle-1 font-weight-bold">
                Company Details
            </span>
            <v-divider />
        </div>
        <v-row>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    Company
                </label>
                <v-text-field
                    v-model="company"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    Address 1
                </label>
                <v-text-field
                    v-model="address1"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    Address 2
                </label>
                <v-text-field
                    v-model="address2"
                    placeholder="Enter address 2"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    City
                </label>
                <v-text-field
                    v-model="city"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    State
                </label>
                <v-select
                    v-model="state"
                    :items="['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY']"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    Zip
                </label>
                <v-text-field
                    v-model="zip"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
        </v-row>
        <div class="my-3">
            <span class="subtitle-1 font-weight-bold">
                Communication Details
            </span>
            <v-divider />
        </div>
        <v-row>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    Work Phone
                </label>
                <v-text-field
                    v-model="workPhone"
                    placeholder="Enter work phone number"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    Cell Phone
                </label>
                <v-text-field
                    v-model="cellPhone"
                    placeholder="Enter cell phone number"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col
                cols="12"
                sm="6"
            >
                <label class="subtitle-2">
                    Fax
                </label>
                <v-text-field
                    v-model="fax"
                    placeholder="Enter fax address"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
        </v-row>
        <v-row
            :class="this.$vuetify.breakpoint.xsOnly ? 'mb-15' : ''"
        >
            <v-col>
                <label class="subtitle-2">
                    Remarks
                </label>
                <v-textarea
                    v-model="remarks"
                    placeholder="Enter remarks"
                    outlined
                    dense
                    hide-details
                />
            </v-col>
        </v-row>
        <v-row>
            <div
                v-if="this.$vuetify.breakpoint.xsOnly"
                class="bottomNav py-2"
            >
                <v-col cols="6">
                    <v-btn
                        color="primary"
                        outlined
                        block
                        large
                        @click="cancel"
                    >
                        Cancel
                    </v-btn>
                </v-col>
                <v-col cols="6">
                    <v-btn
                        color="primary"
                        block
                        large
                        @click="update"
                    >
                        Update
                    </v-btn>
                </v-col>
            </div>
            <v-col
                v-else
            >
                <v-btn
                    color="primary"
                    outlined
                    class="mr-4"
                    @click="cancel"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    @click="update"
                >
                    Update
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import webtmsBackend from '@/services/webtmsBackend';
export default {
    data() {
        return {
            // user properties
            fullName: '',
            account: '',
            ingroup: '',
            company: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            workPhone: '',
            cellPhone: '',
            fax: '',
            remarks: '',
            // component UI properties
            showConfirm: false,
        };
    },
    async mounted() {
        function fixIngroupCasing(input) {
            switch (input.toUpperCase()) {
                case 'SYSOP':
                    return 'Sysop';
                case 'DIRECTOR':
                    return 'Director';
                case 'ADMINISTRATOR':
                    return 'Administrator';
                case 'DISPATCHER':
                    return 'Dispatcher';
                case 'LOCATOR':
                    return 'Locator';
            }
        }

        this.fullName = this.$store.getters.user.name;
        this.account = this.$store.getters.user.account;
        this.ingroup = fixIngroupCasing(this.$store.getters.user.ingroup);
        this.company = this.$store.getters.user.company;
        this.address1 = this.$store.getters.user.address1;
        this.address2 = this.$store.getters.user.address2;
        this.city = this.$store.getters.user.city;
        this.state = this.$store.getters.user.state;
        this.zip = this.$store.getters.user.zip;
        this.workPhone = this.$store.getters.user.phone;
        this.cellPhone = this.$store.getters.user.cell;
        this.fax = this.$store.getters.user.fax;
        this.remarks = this.$store.getters.user.remarks;
    },
    methods: {
        cancel() {
            window.location.reload();
        },
        async update() {
            const user = {
                uid: this.$store.getters.user.uid,
                cid: this.$store.getters.user.cid,
                account: this.account,
                ingroup: this.ingroup,
                homepage: this.$store.getters.user.homepage,
                name: this.fullName,
                company: this.company,
                address1: this.address1,
                address2: this.address2,
                city: this.city,
                state: this.state,
                zip: this.zip,
                phone: this.workPhone,
                fax: this.fax,
                cell: this.cellPhone,
                email: this.$store.getters.user.email,
                remarks: this.remarks,
                birth: this.$store.getters.user.birth,
                death: this.$store.getters.user.death,
            };

            const result = await webtmsBackend.setUserObject(user);

            if (result.status === 'OK') {
                this.$store.commit('SET_USER', result.user);

                this.showConfirm = true;
            }
        },
    },
};
</script>
<style scoped>
.bottomNav {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  background: #fff;
  justify-content: space-evenly;
}
h3 {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;

    /* identical to box height, or 175% */
    display: flex;
    align-items: center;
    letter-spacing: 0.0015em;

    /* Colors/Black and Grey/Header Text */
    color: #35383F;
}
h4 {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;

    /* identical to box height, or 175% */
    display: flex;
    align-items: center;
    letter-spacing: 0.0015em;

    /* Colors/Black and Grey/Header Text */
    color: #35383F;
}
</style>
